import { useState, useEffect } from 'react';
import Breadcrumb from '../Breadcrumb/Breadcrumb';
import axios from '../../axios';
import M from 'materialize-css';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { selectStyles } from '../../Utils/selectStyles';
import { EyeIcon, EyeSlashIcon, PaperAirplaneIcon } from '@heroicons/react/24/solid';

const New = () => {
    const [usuario, setUsuario] = useState({
        name: "",
        email: "",
        password: "",
        password_confirmation: "",
        phone: "",
        sucursales: [],
        rol: ""
    });
    const [validate, setValidate] = useState({
        name: true,
        email: true,
        password: true,
        password_confirmation: true,
        sucursales: true,
        rol: true
    });
    const [sucursales, setSucursales] = useState([]);
    const [roles, setRoles] = useState([]);
    const [showPassword, setShowPassword] = useState(false);
    const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
    const [selectedSucursales, setSelectedSucursales] = useState([]);
    const [selectedRol, setSelectedRol] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        // Sucursales get
        axios.get('api/sucursals')
            .then(response => {
                setSucursales(response.data);
            })
            .catch(e => console.log("error", e));
        
        // Getting all roles
        axios.get('api/roles')
            .then((res) => {
                setRoles(res.data);
            })
            .catch(e => console.log("error ", e));
    }, []);

    // Sync selected sucursales with usuario state
    useEffect(() => {
        const tieneOpcionTodas = selectedSucursales.some(s => s.value === 'todas');
        
        setUsuario(prev => ({
            ...prev,
            sucursales: tieneOpcionTodas 
                ? sucursales.map(s => s.id)  // Si "Todas" está seleccionado, enviar todas las IDs
                : selectedSucursales.map(s => s.value)  // Si no, enviar solo las seleccionadas
        }));
    }, [selectedSucursales, sucursales]);

    // Sync selected rol with usuario state
    useEffect(() => {
        if (selectedRol) {
            setUsuario(prev => ({
                ...prev,
                rol: selectedRol.name
            }));
        }
    }, [selectedRol]);

    const _saveUser = (e) => {
        e.preventDefault();

        if (usuario.password !== usuario.password_confirmation) {
            return alert("los password no coinciden");
        }

        axios.post('api/newuser', usuario)
            .then(res => {
                M.toast({
                    html: '<i class="material-icons">insert_emoticon</i> &nbsp;&nbsp;<span>usuario creado exitosamente</span>',
                    classes: "success-notify"
                });
                setTimeout(() => {
                    navigate("/admin/usuarios");
                }, 3000);
            })
            .catch(e => {
                if (e.response?.data?.errors) {
                    let errors = e.response.data.errors;
                    setValidate({
                        name: !errors.name,
                        email: !errors.email,
                        password: !errors.password,
                        password_confirmation: !errors.password_confirmation,
                        sucursales: !errors.sucursales,
                        rol: !errors.rol
                    });
                    M.toast({
                        html: '<i class="material-icons">insert_emoticon</i> &nbsp;&nbsp;<span>' + e.response.data.message + '</span>',
                        classes: "error-notify"
                    });
                }
            });
    };

    return (
        <div>
            <div className="container-admin-menu">
                <Breadcrumb />
            </div>
            <div className="container-admin-container">
                <div className="container-admin bg-white rounded-lg shadow-md">
                    <h5 className="p-5 text-xl font-bold">Nuevo usuario</h5>
                    <form onSubmit={_saveUser} className="grid grid-cols-12 gap-4 px-5 pb-5">
                        {/* Nombre */}
                        <div className="col-span-12">
                            <div className="flex flex-col gap-1">
                                <label htmlFor="name" className="text-sm font-medium text-gray-600">Nombre *</label>
                                <input
                                    id="name"
                                    type="text"
                                    className="dento-input"
                                    value={usuario.name}
                                    onChange={(e) => setUsuario({ ...usuario, name: e.target.value })}
                                />
                                {!validate.name && (
                                    <span className="text-sm text-red-500">El nombre es obligatorio.</span>
                                )}
                            </div>
                        </div>

                        {/* Teléfono */}
                        <div className="col-span-12 md:col-span-6">
                            <div className="flex flex-col gap-1">
                                <label htmlFor="phone" className="text-sm font-medium text-gray-600">
                                    Teléfono
                                </label>
                                <input
                                    id="phone"
                                    type="number"
                                    className="dento-input"
                                    value={usuario.phone}
                                    onChange={(e) => setUsuario({ ...usuario, phone: e.target.value })}
                                />
                            </div>
                        </div>

                        {/* Email */}
                        <div className="col-span-12 md:col-span-6">
                            <div className="flex flex-col gap-1">
                                <label htmlFor="email" className="text-sm font-medium text-gray-600">
                                    Email *
                                </label>
                                <input
                                    id="email"
                                    type="email"
                                    className="dento-input"
                                    value={usuario.email}
                                    onChange={(e) => setUsuario({ ...usuario, email: e.target.value })}
                                />
                                {!validate.email && (
                                    <span className="text-sm text-red-500">El email es obligatorio.</span>
                                )}
                            </div>
                        </div>

                        {/* Password */}
                        <div className="col-span-12 md:col-span-6">
                            <div className="flex flex-col gap-1">
                                <label htmlFor="password" className="text-sm font-medium text-gray-600">
                                    Password *
                                </label>
                                <div className="relative">
                                    <input
                                        id="password"
                                        type={showPassword ? "text" : "password"}
                                        className="dento-input"
                                        value={usuario.password}
                                        autoComplete="off"
                                        onChange={(e) => setUsuario({ ...usuario, password: e.target.value })}
                                    />
                                    <button
                                        type="button"
                                        className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none"
                                        onClick={() => setShowPassword(!showPassword)}
                                    >
                                        {showPassword ? (
                                            <EyeSlashIcon className="w-5 h-5" />
                                        ) : (
                                            <EyeIcon className="w-5 h-5" />
                                        )}
                                    </button>
                                </div>
                                {!validate.password && (
                                    <span className="text-sm text-red-500">El password es obligatorio.</span>
                                )}
                            </div>
                        </div>

                        {/* Password Confirmation */}
                        <div className="col-span-12 md:col-span-6">
                            <div className="flex flex-col gap-1">
                                <label htmlFor="password_confirmation" className="text-sm font-medium text-gray-600">
                                    Password Confirmación *
                                </label>
                                <div className="relative">
                                    <input
                                        id="password_confirmation"
                                        type={showPasswordConfirm ? "text" : "password"}
                                        className="dento-input"
                                        value={usuario.password_confirmation}
                                        autoComplete="off"
                                        onChange={(e) => setUsuario({ ...usuario, password_confirmation: e.target.value })}
                                    />
                                    <button
                                        type="button"
                                        className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none"
                                        onClick={() => setShowPasswordConfirm(!showPasswordConfirm)}
                                    >
                                        {showPasswordConfirm ? (
                                            <EyeSlashIcon className="w-5 h-5" />
                                        ) : (
                                            <EyeIcon className="w-5 h-5" />
                                        )}
                                    </button>
                                </div>
                                {usuario.password_confirmation.length > 4 && usuario.password !== usuario.password_confirmation && (
                                    <span className="text-sm text-red-400">Los password no coinciden</span>
                                )}
                            </div>
                        </div>

                        {/* Sucursal - React Select Multiple */}
                        <div className="col-span-12 md:col-span-6">
                            <div className="flex flex-col gap-1">
                                <label className="text-sm font-medium text-gray-600">Sucursal *</label>
                               <Select
                                    isMulti
                                    options={[
                                        { value: 'todas', label: '✓ Todas las sucursales', isFixed: true },
                                        ...sucursales.map(s => ({ value: s.id, label: s.nombre_sucursal }))
                                    ]}
                                    value={selectedSucursales}
                                    onChange={options => {
                                        const tieneOpcionTodas = options.some(o => o.value === 'todas');
                                        const teniaOpcionTodas = selectedSucursales.some(o => o.value === 'todas');
                                        
                                        if (tieneOpcionTodas && !teniaOpcionTodas) {
                                            // Se seleccionó "Todas" - seleccionar todas las sucursales
                                            setSelectedSucursales([{ value: 'todas', label: '✓ Todas las sucursales', isFixed: true }]);
                                        } else if (!tieneOpcionTodas && teniaOpcionTodas) {
                                            // Se deseleccionó "Todas" - mantener solo las sucursales reales
                                            const soloSucursalesReales = options.filter(o => o.value !== 'todas');
                                            setSelectedSucursales(soloSucursalesReales);
                                        } else if (!tieneOpcionTodas) {
                                            // Selección normal sin "Todas"
                                            setSelectedSucursales(options);
                                        }
                                    }}
                                    placeholder="Seleccione una sucursal"
                                    classNamePrefix="react-select"
                                    styles={selectStyles}
                                />
                                {!validate.sucursales && (
                                    <span className="text-sm text-red-500">La sucursal es obligatoria.</span>
                                )}
                            </div>
                        </div>

                        {/* Rol - Select nativo estilizado */}
                        <div className="col-span-12 md:col-span-6">
                            <div className="flex flex-col gap-1">
                                <label className="text-sm font-medium text-gray-600">Rol *</label>
                                <select
                                    className="dento-input h-[44px!important] browser-default"
                                    value={usuario.rol}
                                    onChange={e => {
                                        const selected = roles.find(r => r.name === e.target.value);
                                        setSelectedRol(selected);
                                        setUsuario({ ...usuario, rol: e.target.value });
                                    }}
                                >
                                    <option value="" disabled>Seleccione un rol de usuario</option>
                                    {roles.map((item) => (
                                        <option key={item.id} value={item.name}>{item.name}</option>
                                    ))}
                                </select>
                                {!validate.rol && (
                                    <span className="text-sm text-red-500">El rol es obligatorio.</span>
                                )}
                            </div>
                        </div>

                        {/* Submit Button */}
                        <div className="col-span-12 pt-8 flex justify-end">
                            <button  type="submit"
                                className="inline-flex items-center gap-1 px-6 py-2.5 bg-[#03f] text-white hover:bg-white hover:text-[#03f] hover:border-[#03f] sombra-azul-chica font-medium rounded-md transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 sombra-azul-pequeña cursor-pointer"
                            >
                                Guardar
                                <PaperAirplaneIcon className="w-5 h-5" />
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default New;